import ImageThumbnailButton from './component'
export default ImageThumbnailButton
